import React from 'react';

export default function PageTemplate ({ children }) {
    return (
        <div className="mtt-template-content mtt-template-content--ads">
            <div className="mtt-template-content__inner page_container">
                <div className="mtt-template-content__content">
                    { children }
                </div>
            </div>
        </div>
    )
}
